import * as React from 'react';
import { IAllAddresses } from '../types/buybox';

export default (
    index: number,
    address: IAllAddresses,
    onProductClickChange: (index: number, productIndex: number) => void,
    removeAddress: (index: number, productIndex: number, inputRef: React.MutableRefObject<HTMLInputElement | null>) => void,
    removeLabelText: string,
    propertyLabel: string,
    propertyValue: string,
    inputRef: React.MutableRefObject<HTMLInputElement | null>
) => (
    <li>
        <label>{`${propertyLabel}: ${propertyValue}`}</label>
        <ul>
            {address.relatedProduct &&
                address.relatedProduct.length > 0 &&
                address.relatedProduct.map((product, productIndex) => (
                    <li>
                        <label>
                            <input
                                type='checkbox'
                                defaultChecked={address.addressVerified.isChecked}
                                onChange={() => onProductClickChange(index, productIndex)}
                            />
                            {`${product.Name}`}
                            <button className='removeItem' onClick={() => removeAddress(index, productIndex, inputRef)}>
                                {removeLabelText}
                            </button>
                        </label>
                    </li>
                ))}
        </ul>
    </li>
);
